export { MarketProperty } from './market-property'
